import { IBFHistoryRecordDefinition } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";

export type IBFDownload = {};

export const IBF_DOWNLOAD = {
  value: 0x20000,
  name: "IBF_DOWNLOAD",
  size: 0,
  parse: (): IBFDownload => {
    return {};
  },
} satisfies IBFHistoryRecordDefinition<IBFDownload>;
